/**
 * Web-compatible wrapper for react-native-draggable-flatlist
 * On web, dragging doesn't work well, so we just render a regular FlatList
 */

import React from 'react';
import { FlatList } from 'react-native';

// On web, DraggableFlatList becomes a regular FlatList (no drag functionality)
const DraggableFlatList = React.forwardRef<any, any>((props, ref) => {
  const {
    // Remove drag-specific props
    onDragBegin,
    onDragEnd,
    onPlaceholderIndexChange,
    onRelease,
    activationDistance,
    animationConfig,
    autoscrollSpeed,
    autoscrollThreshold,
    containerStyle,
    dragItemOverflow,
    simultaneousHandlers,
    
    // Keep regular FlatList props
    data,
    renderItem,
    keyExtractor,
    ...flatListProps
  } = props;

  // Render regular FlatList with the original renderItem
  // Note: renderItem in draggable-flatlist provides { item, drag, isActive }
  // We need to adapt it to regular FlatList format
  const adaptedRenderItem = ({ item, index }) => {
    // Call original renderItem but without drag/isActive
    // Most components check if drag exists before using it
    return renderItem({
      item,
      index,
      drag: () => {}, // No-op on web
      isActive: false,
      getIndex: () => index,
    });
  };

  return (
    <FlatList
      ref={ref}
      data={data}
      renderItem={adaptedRenderItem}
      keyExtractor={keyExtractor}
      {...flatListProps}
    />
  );
});

DraggableFlatList.displayName = 'DraggableFlatList';

// ScaleDecorator - just renders children on web (no animation)
export const ScaleDecorator = ({ children }: { children: React.ReactNode }) => {
  return <>{children}</>;
};

// OpacityDecorator - just renders children on web (no animation)
export const OpacityDecorator = ({ children }: { children: React.ReactNode }) => {
  return <>{children}</>;
};

// ShadowDecorator - just renders children on web (no animation)
export const ShadowDecorator = ({ children }: { children: React.ReactNode }) => {
  return <>{children}</>;
};

export default DraggableFlatList;

